import {Badge, BadgeVariant} from 'Badge';

import type {BadgeProps} from 'Badge';

import type {SidebarMenuItemStyles, SidebarMenuItemProps} from 'SidebarMenu/types';

type MenuItemBadgeProps = SidebarMenuItemStyles & Pick<SidebarMenuItemProps, 'badge'> & Pick<BadgeProps, 'hasStroke'>;

export const MenuItemBadge: React.FC<MenuItemBadgeProps> = ({disabled, badge, isSelected, hasStroke}) => {
  const type = typeof badge;

  if (type === 'undefined' || badge === null) {
    return null;
  }

  if (type === 'function' || type === 'object') {
    return badge;
  }

  let variant = BadgeVariant.Grey;

  if (disabled) {
    variant = BadgeVariant.Disabled;
  } else if (isSelected) {
    variant = BadgeVariant.Accent;
  }

  return (
    <Badge variant={variant} hasStroke={hasStroke}>
      {badge}
    </Badge>
  );
};
